export default __webpack_public_path__ + "static/business-posters-4c367eee626fd93c35f5ff75a06faf02.webp";